// The route matches on cases_documents__legal_files.id, NOT legal_file_id. Both ids sit on
// the same file object, so taking the wrong one builds a URL that looks right and 404s.
export const caseDocumentFileDownloadUrl = (p: {
    caseId: string;
    caseDocumentId: string;
    caseDocumentFileId: string;
}): string =>
    `${env.REACT_APP_API_URL}/web/cases/${p.caseId}/documents/${p.caseDocumentId}/files/${p.caseDocumentFileId}/download`;
